import React, { useEffect, useState, useContext } from "react";
import Footer from "../components/footer";
import Header from "../components/header";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import axios from "axios";
import { CartContext } from "../../../contexts/cartContext";
import { CurrencyContext } from "../../../contexts/currencyContext"; // Import context
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import RequestModal from "../components/RequestModal";
import LoaderHomePd from "../components/loaderHomePd";


const Artwork = () => {

    const location = useLocation();
    //const { id } = location.state || {};

    const removeH1Tag = (html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        doc.querySelectorAll("h1").forEach(h1 => h1.replaceWith(...h1.childNodes)); // Removes <h1> but keeps its content
        return doc.body.innerHTML;
    };

    const { productTitleAndId } = useParams();

    // Extract the title and ID
    const [productTitle, id] = productTitleAndId.split(/-(?=\d+$)/); // Split by the last '-' before the ID


    const [wishlists, setWishlists] = useState([]);
    const [cartlists, setCartlists] = useState([]);
    const { wishlist, addToWishlist } = useContext(CartContext);
    const { cart, addToCartList } = useContext(CartContext);


    const navigate = useNavigate();
    const [artworkDetails, setArtworkDetails] = useState([]);
    const [similarArtwork, setSimilarArtwork] = useState([]);
    const [isVisible, setIsVisible] = useState(true);
    const [activeTab, setActiveTab] = useState(1);
    const [policyDetailsAll, setPolicyDetailsAll] = useState([]);
    const [selectedOption, setSelectedOption] = useState("wall-red");

    const [loading, setLoading] = useState(true);

    const artistId = artworkDetails[0]?.artist_id;
    const productId = artworkDetails[0]?.product_id;

    const { currencyContxt } = useContext(CurrencyContext); // Use context

    const SHOWCOUNT = 10;


    const closeModel = () => {
        setIsVisible(!isVisible);
    }
    const handleViewOnWall = () => {
        setIsVisible(!isVisible);

    };

    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
    };


    const getArtworkDetails = async () => {
        try {
            const response = await axios.get('https://igapi.heuristticminds.com/api/UserInterface/Get-GetArtworkDetailsByProductID?product_id=' + id)
            setArtworkDetails(response.data);
        } catch (error) {
            console.log(error);
        }
    }
    const GetPolicyDetailsAll = async () => {
        try {
            const response = await axios.get('https://igapi.heuristticminds.com/api/PolicyList/Get-GetPolicyDetailsForBuyer')
            setPolicyDetailsAll(response.data);
        } catch (error) {
            console.log(error);
        }
    }




    const getSimilarArtwork = async () => {
        try {
            if (artworkDetails.length > 0) {
                const response = await axios.get('https://igapi.heuristticminds.com/api/UserInterface/Get-GetSimilarArtworkByArtistID?artist_id=' + artistId + '&product_id=' + productId)

                setLoading(true);
                const delay = new Promise(resolve => setTimeout(resolve, 500)); // 500 ms delay
                await delay;
                setSimilarArtwork(response.data);
            }
        }
        catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }

    }


    const handleArtist = (artistId, artistName) => {
        const artist = artistName.replace(/ /g, '-'); // Replace spaces with '-'
        navigate(`/artist/${artist}-${artistId}`, { state: { artistId: artistId}});
        window.scrollTo({
            top: 0,
            behavior: "instant"
        });
    };

    const handleQuickview = (pdid, productTitle) => {
        const formattedTitle = productTitle.replace(/ /g, '-'); // Replace spaces with '-'
        navigate(`/artwork/${formattedTitle}-${pdid}`, { state: { id: pdid}});
        window.scrollTo({
            top: 0,
            behavior: "instant"
        });
    };

    useEffect(() => {
        getArtworkDetails();
        getSimilarArtwork();
        GetPolicyDetailsAll();
    }, [id, artistId, productId]);

    const userInfo = JSON.parse(localStorage.getItem('user-info'));
    //Add to Cart Click

    // Fetch the CartList data when the page loads
    const fetchCartListData = async () => {

        if (userInfo && userInfo.buyer_id) {
            try {
                const response = await fetch(`https://igapi.heuristticminds.com/api/CartList/Get-GetCartListByUserID?user_id=${userInfo.buyer_id}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const cartlistData = await response.json();

                if (cartlistData && Array.isArray(cartlistData)) {
                    setCartlists(cartlistData); // Store complete CartList items from API
                } else {
                    setCartlists([]); // Set an empty cartlist if no data is returned
                }

            } catch (error) {
                console.error('Error fetching cartlist:', error);
            }
        } else {
            const localCartlist = getCartlistFromLocalStorage();
            setCartlists(localCartlist); // Store complete cartlist items from local storage
        }
    };

    // Handler for Wishlist  and Cart Button Click
    const handleCartlistClick = async (item) => {

        const itemIsInCartlist = isInCart(item.product_id);

        if (userInfo && userInfo.buyer_id) {

            try {
                const payload = {
                    customer_id: userInfo.buyer_id,
                    product_id: item.product_id,
                };
                const response = await fetch("https://igapi.heuristticminds.com/api/CartList/Add-SaveCartList", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload),
                });

                if (!response.ok) {
                    throw new Error(`Failed to update cartlist: ${response.statusText}`);
                }

                // Extract JSON data from the response
                const { action } = await response.json(); // Destructuring to get action flag


                // Display success message based on the action performed
                if (action === "Add") {
                    toast.success("Artwork Added to Cart !!");
                } else if (action === "Remove") {
                    toast.error("Artwork Removed from Cart !!");
                }
                // Fetch the updated cartlist after modification
                await fetchCartListData();  // Refresh state with the updated cartlist from the database
            } catch (error) {
                console.error("Error syncing cartlist item:", item.product_id, error);
            }
        }
        else {
            if (itemIsInCartlist) {
                // Remove from Cartlist logic
                removeFromCartlist(item.product_id);
                toast.error("Artwork Removed from Cart !!");
            } else {
                addToCartList(item);
                toast.success("Artwork Added to Cart !!");
            }
        }

        handleCartlistUpdate(); // Refresh wishlist state after adding/removing
    };

    // Helper function to get cartlist from localStorage
    const getCartlistFromLocalStorage = () => {
        return JSON.parse(localStorage.getItem('cart')) || [];
    };


    // Context or state management function
    const handleCartlistUpdate = () => {
        if (userInfo && userInfo.buyer_id) {
            fetchCartListData(); // Fetch from API
        } else {
            const updatedCart = getCartlistFromLocalStorage(); // Fetch from local storage
            setCartlists(updatedCart); // Update state
        }
    };


    // Function to remove item from the wishlist
    const removeFromCartlist = (productId) => {
        const updatedCart = cartlists.filter(item => item.product_id !== productId);
        setCartlists(updatedCart); // Update state
        localStorage.setItem('cart', JSON.stringify(updatedCart)); // Update local storage
    };
    const isInCart = (productId) => {
        return cartlists.some(item => item.product_id === productId);
    };

    //Add to Cart Ends Here

    //Wishlist Click

    // Fetch the wishlist data when the page loads
    const fetchWishlistData = async () => {

        if (userInfo && userInfo.buyer_id) {
            try {
                const response = await fetch(`https://igapi.heuristticminds.com/api/WishList/Get-GetWishListByUserID?user_id=${userInfo.buyer_id}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const wishlistData = await response.json();

                if (wishlistData && Array.isArray(wishlistData)) {
                    setWishlists(wishlistData); // Store complete wishlist items from API
                } else {
                    setWishlists([]); // Set an empty wishlist if no data is returned
                }

            } catch (error) {
                console.error('Error fetching wishlist:', error);
            }
        } else {
            const localWishlist = getWishlistFromLocalStorage();
            setWishlists(localWishlist); // Store complete wishlist items from local storage
        }
    };


    // Handler for Wishlist Button Click
    const handleWishlistClick = async (item) => {

        const itemIsInWishlist = isInWishlist(item.product_id);

        if (userInfo && userInfo.buyer_id) {

            try {
                const payload = {
                    customer_id: userInfo.buyer_id,
                    product_id: item.product_id,
                };
                const response = await fetch("https://igapi.heuristticminds.com/api/WishList/Add-SaveWishList", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload),
                });

                if (!response.ok) {
                    throw new Error(`Failed to update wishlist: ${response.statusText}`);
                }

                // Extract JSON data from the response
                const { action } = await response.json(); // Destructuring to get action flag


                // Display success message based on the action performed
                if (action === "Add") {
                    toast.success("Artwork Added to Wishlist !!");
                } else if (action === "Remove") {
                    toast.error("Artwork Removed from Wishlist !!");
                }
                // Fetch the updated wishlist after modification
                await fetchWishlistData();  // Refresh state with the updated wishlist from the database
            } catch (error) {
                console.error("Error syncing wishlist item:", item.product_id, error);
            }
        }
        else {
            if (itemIsInWishlist) {
                // Remove from wishlist logic
                removeFromWishlist(item.product_id);
                toast.error("Artwork Removed from Wishlist 2 !!");
            } else {
                addToWishlist(item);
                toast.success("Artwork Added to Wishlist !!");
            }
        }

        handleWishlistUpdate(); // Refresh wishlist state after adding/removing
    };


    // Helper function to get wishlist from localStorage
    const getWishlistFromLocalStorage = () => {
        return JSON.parse(localStorage.getItem('wishlist')) || [];
    };

    // Context or state management function
    const handleWishlistUpdate = () => {
        if (userInfo && userInfo.buyer_id) {
            fetchWishlistData(); // Fetch from API
        } else {
            const updatedWishlist = getWishlistFromLocalStorage(); // Fetch from local storage
            setWishlists(updatedWishlist); // Update state
        }
    };

    const isInWishlist = (productId) => {
        return wishlists.some(item => item.product_id === productId);
    };

    // Function to remove item from the wishlist
    const removeFromWishlist = (productId) => {
        const updatedWishlist = wishlists.filter(item => item.product_id !== productId);
        setWishlists(updatedWishlist); // Update state
        localStorage.setItem('wishlist', JSON.stringify(updatedWishlist)); // Update local storage
    };


    useEffect(() => {
        const loadWishlist = async () => {
            await fetchWishlistData();
        };
        loadWishlist();
        const loadCartlist = async () => {
            await fetchCartListData();
        };
        loadCartlist();
    }, []);
    useEffect(() => {
        setWishlists(wishlist);
        setCartlists(cart);
    }, [wishlist, cart]); // This will trigger every time the wishlist state changes


    //WishList Click ends

    const handleOptionChange = (event) => {
        setSelectedOption(event.target.value);
    };

    // Fetch wishlist from localStorage when component mounts
    /* useEffect(() => {
        const savedWishlist = getWishlistFromLocalStorage();
        setWishlists(savedWishlist);
    }, []); */

    //const selectedCurrency = JSON.parse(localStorage.getItem('selectedCurrency'));
    const [isModalOpen, setModalOpen] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [selectedPd, setSelectedPd] = useState(null);

    const handleRequestPrice = (id, pdTitle) => {
        setModalOpen(true);
        setSelectedId(id);
        setSelectedPd(pdTitle);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
        setSelectedId(null);
        setSelectedPd(null);
    };
    return (
        <>
            <Header />
            <div style={{ marginTop: '150px' }}>
                <div className="container">
                    <div className="row">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-4">
                                <li className="breadcrumb-item"><Link to={'/'}>Home</Link></li>
                                <li className="breadcrumb-item"><Link to={'/'}>Artworks</Link></li>
                                <li className="breadcrumb-item"><a>{artworkDetails[0]?.category}</a></li>
                                <li className="breadcrumb-item active" aria-current="page">{artworkDetails[0]?.productTitle}</li>
                            </ol>
                        </nav>
                        <div className="col-md-6 pe-3 pe-sm-5 mb-5">
                            <img src={`../../images/products/full/${artworkDetails[0]?.image}`} className="w-75" />
                        </div>

                        <div className="col-md-6 ps-2 ps-sm-5">

                            <div className="pdd_details mb-2">
                                <h3 className="pdd_title">{artworkDetails[0]?.productTitle}</h3>
                                <p className="artby"><i className="bi bi-brush"></i>Art by: <span className="btn_artist" onClick={() => handleArtist(artworkDetails[0]?.artist_id, artworkDetails[0]?.artistName)}>{artworkDetails[0]?.artistName}</span></p>

                                {
                                    artworkDetails[0]?.price_on_demand === 1 ? <><span className="btn_req mb-4" onClick={() => handleRequestPrice(artworkDetails[0]?.product_id, artworkDetails[0]?.productTitle)}>Request Price</span></> :

                                        <>
                                            <div className="pdd_price">
                                                {currencyContxt.icon} {(artworkDetails[0]?.price / currencyContxt.value).toFixed(2)}
                                                {
                                                    artworkDetails[0]?.discountRate === 0 ? ''
                                                        : <>
                                                            <span className="discount"><span className="old_price">{currencyContxt.icon} {(artworkDetails[0]?.gstMRP / currencyContxt.value).toFixed(2)}</span><span className="discount">({artworkDetails[0]?.discountRate}%)</span></span>
                                                        </>
                                                }
                                                {
                                                    currencyContxt.currency == "INR" ?
                                                        <small className="pdd_taxes">inclusive of all taxes</small>
                                                        :
                                                        <></>
                                                }
                                            </div>
                                            <div className="clearfix"></div>

                                            <a href="#" className="btn1 me-3" onClick={() => handleCartlistClick(artworkDetails[0])}><i className="bi bi-bag"></i> Buy Now</a>
                                            <a href="#" className={`${isInCart(artworkDetails[0]?.product_id) ? 'btn3' : 'btn2'} me-3`} onClick={() => handleCartlistClick(artworkDetails[0])}><i className="bi bi-bag"></i> Add to cart</a>
                                            <a href="#" className={`${isInWishlist(artworkDetails[0]?.product_id) ? 'btn3' : 'btn2'}`} onClick={() => handleWishlistClick(artworkDetails[0])}><i className="bi bi-suit-heart"></i> Add to Wishlist</a>
                                        </>
                                }

                                <div className="clearfix"></div>

                                <div className="d-flex align-items-center">
                                    {
                                        artworkDetails[0]?.category !== 'Sculpture' && (
                                            <span className="btn_link me-4">
                                                <div className='pulse-wrap' onClick={() => handleViewOnWall()}>
                                                    <span className='pulse-button'><i className="bi bi-eye-fill"></i></span> View on the wall
                                                </div>
                                            </span>
                                        )

                                    }


                                    <div className="share_links">
                                        <span className="share_title"><i className="bi bi-reply-fill"></i> Share Link</span>
                                        <span className="share_link"><i className="bi bi-facebook"></i></span>
                                        <span className="share_link"><svg xmlns="http://www.w3.org/2000/svg" style={{ marginTop: '-3px' }} width="16" height="16" fill="currentColor" className="bi bi-twitter-x" viewBox="0 0 16 16">
                                            <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z" />
                                        </svg></span>
                                        <span className="share_link"><i className="bi bi-linkedin"></i></span>
                                        <span className="share_link"><i className="bi bi-pinterest"></i></span>
                                    </div>
                                </div>

                            </div>
                            <div className="overview">

                                <ul className="overview_list">
                                    <li><span>Artwork code</span>{artworkDetails[0]?.artworkCode}</li>
                                    <li><span>{artworkDetails[0]?.category}</span>{artworkDetails[0]?.categoryType}</li>
                                    <li><span>Size</span>{artworkDetails[0]?.size}</li>
                                    <li><span>Artist certificate</span>{artworkDetails[0]?.certificate}</li>
                                    <li><span>Year Created</span>{artworkDetails[0]?.created_in}</li>
                                    <li><span>Original Artwork</span>{artworkDetails[0]?.original_painting}</li>
                                    {/*<li><span>Print Available</span>{artworkDetails[0]?.printAvailable}</li>*/}
                                    {artworkDetails[0]?.printAvailable === 'Yes' && (
                                    <li>
                                        <span>Print Available</span> {artworkDetails[0]?.printAvailable}
                                    </li>
                                    )}
                                    <li><span>Shipping Method</span>{artworkDetails[0]?.packingMode}</li>
                                </ul>

                                <div>
                                    {
                                        policyDetailsAll.map(policyDetails => (
                                            <div key={policyDetails.id} className="policy_style">
                                                <b className="title">{policyDetails.title}:</b>
                                                <span className="details" dangerouslySetInnerHTML={{ __html: policyDetails?.policyDetails }} />
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>

                        </div>

                        <div className="col-sm-12">
                            <div className="tabs-container mb-4">
                                <div className="tabs">
                                    <div
                                        className={activeTab === 1 ? 'tab active' : 'tab'}
                                        onClick={() => handleTabClick(1)}
                                    >
                                        DESCRIPTION
                                    </div>
                                    <div
                                        className={activeTab === 2 ? 'tab active' : 'tab'}
                                        onClick={() => handleTabClick(2)}
                                    >
                                        TERMS & CONDITIONS
                                    </div>
                                </div>
                                <div className="tab-content">
                                    {activeTab === 1 && (
                                        <div dangerouslySetInnerHTML={{ __html: removeH1Tag(artworkDetails[0]?.description) }} />
                                    )}                                     
                                    
                                    {activeTab === 2 && (
                                        <div dangerouslySetInnerHTML={{ __html: removeH1Tag(artworkDetails[0]?.conditions) }} />
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-12">
                            <h3>More Artwork From <b>{artworkDetails[0]?.artistName}</b></h3>

                            <div>
                                {
                                    loading ? (<LoaderHomePd />
                                    ) : (
                                        <div className="results">
                                            {
                                                similarArtwork.map((artwork, index) => {
                                                    return index + 1 <= SHOWCOUNT ?
                                                        <div className="pd_item" key={artwork?.product_id}>
                                                            <div className="img_box">
                                                                <img src={`../../images/products/full/${artwork?.image}`} className="pd_img" alt="" />
                                                                <a href="#" className="wishlist_link" title="WISHLIST"
                                                                    onClick={() => handleWishlistClick(artwork)}>
                                                                    <i className={`${isInWishlist(artwork?.product_id) ? 'bi bi-suit-heart-fill text-danger' : 'bi bi-suit-heart'}`}></i>
                                                                </a>
                                                                <span className="q_view" onClick={() => handleQuickview(artwork?.product_id, artwork?.productTitle)}><i className="bi bi-eye"></i> Detail View</span>
                                                                <span className="size">Size: <b>{artwork?.size}</b></span>
                                                            </div>
                                                            <div className="pd_content">
                                                                <span className="pd_brand">{artwork?.productTitle}</span>
                                                                <span className="pd_title">{artwork?.category}: {artwork?.categoryType}</span>
                                                                <span className="pd_title">Art by: <span className="btn_artist1" onClick={() => handleArtist(artwork?.artist_id, artwork?.artistName)}>{artwork?.artistName}</span></span>
                                                                {
                                                                    artwork?.price_on_demand === 1 ? <><span className="btn_req" onClick={() => handleRequestPrice(artwork?.product_id, artwork?.productTitle)}>Request Price</span></> :

                                                                        <div className="Price">
                                                                            {currencyContxt.icon} {(artwork?.price / currencyContxt.value).toFixed(2)}
                                                                            {
                                                                                artwork?.discountRate === 0 ? ''
                                                                                    : <>
                                                                                        <span className="old_price">{currencyContxt.icon} {(artwork?.gstMRP / currencyContxt.value).toFixed(2)}</span><span className="discount">({artwork?.discountRate}%)</span>
                                                                                    </>
                                                                            }
                                                                            {
                                                                                currencyContxt.currency == "INR" ?
                                                                                    <small>Including GST</small>
                                                                                    :
                                                                                    <></>
                                                                            }
                                                                        </div>
                                                                }
                                                            </div>
                                                        </div>
                                                        :
                                                        undefined
                                                })
                                            }
                                        </div>
                                    )}
                            </div>
                        </div>
                        <div className={`view_ordermodel ${!isVisible ? 'd-block' : ''}`}>
                            <div className="model_con">
                                <span className="cls_model" onClick={() => closeModel()}><i className="bi bi-x"></i></span>
                                <div className={`wall-style ${selectedOption}`}>
                                    <div className={`overflow-hidden m-auto ${artworkDetails[0]?.orientation_id == 164 ? 'photoframeh' : 'photoframe'}`}>
                                        <figure>
                                            <div className="outerBevel">
                                                <div className="flatSurface">
                                                    <div className="innerBevel">
                                                        <div className="banner_frame">
                                                            <div className="item">
                                                                <img src={`../../images/products/full/${artworkDetails[0]?.image}`} className="w-100" />

                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </figure>
                                    </div>

                                    <div className="rbtn_color">
                                        <label>
                                            <input
                                                type="radio"
                                                value="wall-red"
                                                checked={selectedOption === 'wall-red'}
                                                onChange={handleOptionChange}
                                            />
                                            <span className="option op1"></span>

                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                value="wall-pink"
                                                checked={selectedOption === 'wall-pink'}
                                                onChange={handleOptionChange}
                                            />
                                            <span className="option op2"></span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                value="wall-green"
                                                checked={selectedOption === 'wall-green'}
                                                onChange={handleOptionChange}
                                            />
                                            <span className="option op3"></span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                value="wall-yellow"
                                                checked={selectedOption === 'wall-yellow'}
                                                onChange={handleOptionChange}
                                            />
                                            <span className="option op4"></span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                value="wall-blue"
                                                checked={selectedOption === 'wall-blue'}
                                                onChange={handleOptionChange}
                                            />
                                            <span className="option op5"></span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                value="wall-white"
                                                checked={selectedOption === 'wall-white'}
                                                onChange={handleOptionChange}
                                            />
                                            <span className="option op6"></span>
                                        </label>
                                    </div>
                                </div>




                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer position="bottom-right" />
            <RequestModal isOpen={isModalOpen} onClose={handleCloseModal} id={selectedId} pdTitle={selectedPd} />
            <Footer />

        </>
    )
}
export default Artwork;